import { Avatar as NovaAvatar, AvatarProps as NovaAvatarProps } from '@fme-nova/components'
import { AvatarProps as MuiAvatarProps, default as MuiAvatar } from '@mui/material/Avatar'

import { createComponentWrapperWithRef } from '../../theme'

export const Avatar = createComponentWrapperWithRef<MuiAvatarProps | NovaAvatarProps>(
  {
    mui: MuiAvatar,
    nova: NovaAvatar,
  },
  'Avatar',
)
